import React from 'react';
import { Box, Paper, CircularProgress, Typography } from '@mui/material';
import DAlogo from './da-logo.png';

const FullScreenLoader = ({
  message,
  children,
}: {
  message: string;
  children?: React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 1300,
        px: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minWidth: 320,
          position: 'relative',
          overflow: 'hidden',
          mt: -10,
        }}
      >
        {/* Brand color bar */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: 6,
            width: '100%',
            backgroundColor: '#252525', // Replace with your brand color
          }}
        />

        {/* Logo */}
        <Box sx={{ mb: 0, mt: 1 }}>
          <img
            src={DAlogo}
            alt="Logo"
            // style={{ height: 40, objectFit: 'contain' }}
            style={{
              maxHeight: '100%',
              maxWidth: '160px', // prevent stretching
              objectFit: 'contain',
            }}
          />
        </Box>

        {/* Spinner */}
        {/* <CircularProgress sx={{ mb: 3 }} /> */}
        <CircularProgress
          thickness={5}
          size={40}
          sx={{
            color: '#1976d2',
            mb: 3,
          }}
        />

        {/* Main message */}
        <Typography variant="h6" gutterBottom>
          {message}
        </Typography>

        {/* Secondary message */}
        {children && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: 'italic', textAlign: 'center', maxWidth: 280 }}
          >
            {children}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default FullScreenLoader;
